import { Box } from '@mui/material';
import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
import React, { memo, useMemo } from 'react';

// Module-level so GoogleMap doesn't re-apply options (and restyle the map) on every render
const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const mapOptions = {
  disableDefaultUI: true, // Hide all default controls
  gestureHandling: "none", // Prevent any interactions
  zoomControl: true,
  scrollwheel: false,
  draggable: false,
  mapTypeControl: true,
  styles: [
    {
      featureType: "poi", // Target Points of Interest (POIs)
      elementType: "labels", // Hide labels (pins)
      stylers: [{ visibility: "off" }],
    },
  ],
};

const MapCard = ({
  lat,
  lon,
}) => {
  const hasPosition = lat != null && lon != null;

  const center = useMemo(() => ({
    lat: lat || 37.7749, // Default latitude (San Francisco)
    lng: lon || -122.4194, // Default longitude (San Francisco)
  }), [lat, lon]);

  return (
    <Box sx={{
      width: "100%",
      height: 320,
      borderTop: "1px solid var(--c-border)",
    }}>
      <LoadScript googleMapsApiKey="AIzaSyBIfXxS8Q_X-7vcVYjKEqin-jryLK08F5I">
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={18}
          options={mapOptions}
          mapTypeId="roadmap"
        >
          {hasPosition && <MarkerF position={center} />}
        </GoogleMap>
      </LoadScript>
    </Box>
  )
}

export default memo(MapCard);
